import React from "react";
import "./Uitag.css";
import UiIcon from "../UiIcon";

const UI_TAG_TYPE = {
  successColor: "#2CB42B",
  highlightColor: "#FFA500",
  brand: "#FCA2AD",
  lightCream: "#F4D5B7",
  critical: "#B22222",
  informative: "#FFEDF3",
  paleOrange: "#FFD7A8",
  lightBlue: "#ADD8E6",
  lightGreen: "#97E797",
};

function UiTag({
  content,
  className = "",
  style = {},
  uiTagType = UI_TAG_TYPE.brand,
  icon,
  fontSize = 12,
  iconSize = 14,
  size = "sm",
  bold = 400,
  rounded = false,
  fontWeight = 400,
  onClick = () => {},
}) {
  if (size) className += ` btn-${size} `;
  if (rounded) className += "ui-tag-rounded";
  const tagClassNames = `ui-tag ${className}`;
  const tagStyle = {
    backgroundColor: uiTagType,
    fontWeight: bold,
    fontWeight: `${fontWeight}`,
    fontSize: `${fontSize}px`,
    ...style,
  };

  function handleOnClick(e) {
    e.preventDefault();
    e.stopPropagation();
    onClick(e);
  }

  return (
    <React.Fragment>
      <div className={tagClassNames} style={tagStyle}>
        <span className="ui-tag-content">{content}</span>
        {icon && (
          <UiIcon
            className="ui-tag-icon"
            onClick={handleOnClick}
            icon={icon}
            alt="icon"
            size={iconSize}
          />
        )}
      </div>
    </React.Fragment>
  );
}

export default UiTag;
export { UI_TAG_TYPE };
